import * as type from './mutation-types'
import * as API from './api'
import { ajax } from '@/utils/fetch'

// 获取首页轮播图展示列表
export const getAdvertiseList = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETADVERTISELIST_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getAdvertiseList, {
            commit
        },
        data,
        type.GETADVERTISELIST_RECEIVE
    )
};
// 获取首页分页查询积分商品集合
export const getProductList = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETPRODUCTLIST_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getProductList, {
            commit
        },
        data,
        type.GETPRODUCTLIST_RECEIVE
    )
};
// 个人中心根据礼包商品 ID 获取礼包信息
export const getProduct = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETPRODUCT_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getProduct, {
            commit
        },
        data,
        type.GETPRODUCT_RECEIVE
    )
};
// 获取用户积分收支明细
export const getIncomeDetail = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETINCOMEDETAIL_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getIncomeDetail, {
            commit
        },
        data,
        type.GETINCOMEDETAIL_RECEIVE
    )
};
// 个人中心根据用户 UID 获取用户积分余额
export const getUserBalance = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETUSERBALANCE_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getUserBalance, {
            commit
        },
        data,
        type.GETUSERBALANCE_RECEIVE
    )
};
// 个人中心用户购买积分礼包接口
export const pay = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.PAY_REQUEST, data)
        // http 请求
    return ajax.postPay(
        API.pay, {
            commit
        },
        data,
        type.PAY_RECEIVE
    )
};
// 获取礼包购买记录
export const getPurchaseHi = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETPURCHASEHI_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getPurchaseHi, {
            commit
        },
        data,
        type.GETPURCHASEHI_RECEIVE
    )
};